import React from 'react';
import { Wrap } from '@leafwell/components';
import Image from 'next/image';

import HeadingBody from './heading-body';
import { BlockOnceApproved } from 'types/block-once-approved';

const OnceApproved: React.FC<BlockOnceApproved> = ({
  title,
  perksList,
  image,
}) => {
  return (
    <Wrap className="gap-y-0" tagName="section">
      {perksList ? (
        <div className="mb-6 sm:mb-10">
          <HeadingBody
            {...{
              className: 'text-center font-semibold',
              level: '2',
              tagName: 'h2',
              title: title,
            }}
          />
        </div>
      ) : null}
      <div
        className={[
          'flex justify-between md:flex-row',
          perksList && perksList.length
            ? 'flex-col-reverse md:flex-row'
            : 'flex-col',
        ].join(' ')}
      >
        {perksList && perksList.length ? (
          <ul className="md:w-1/3">
            {perksList.map((perk, index) => (
              <li key={index} className="mb-8 md:mb-10">
                <p className="mb-1.5 md:mb-4 text-xl 2xl:text-2xl">
                  {perk.title}
                </p>
                <p className="">{perk.description}</p>
              </li>
            ))}
          </ul>
        ) : (
          <div className="md:w-1/3 mb-4 md:mb-0 text-center md:text-left">
            <HeadingBody
              {...{
                className: 'font-semibold',
                level: '2',
                tagName: 'h2',
                title: title,
              }}
            />
          </div>
        )}
        <div className="w-full md:w-7/12 lg:w-1/2 xl:w-5/12 h-[280px] xs:h-[320px] sm:h-[360px] md:h-[410px] mb-4 md:mb-0 rounded overflow-hidden">
          <Image
            className="object-cover w-full h-full"
            src={image?.src}
            width={600}
            height={400}
            alt={image?.alt ? image.alt : `${title} image`}
            // quality={50}
            priority={true}
          />
        </div>
      </div>
    </Wrap>
  );
};

export default OnceApproved;
